import React from 'react';
import Div from '../Div';
import './portfolio.scss';

// Helper function to extract YouTube video ID
const getYoutubeVideoId = (url) => {
  if (!url) return null;
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/
  ];
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }
  return null;
};

// Helper function to get YouTube thumbnail URL
const getYoutubeThumbnail = (videoId) => {
  if (!videoId) return null;
  // Using maxresdefault for highest quality, falls back to hqdefault
  return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
};

export default function Portfolio({ href, src, title, subtitle, variant, onClick, isVideo }) {
  // Check if this is a YouTube video
  const videoId = isVideo && href ? getYoutubeVideoId(href) : null;
  const youtubeThumb = videoId ? getYoutubeThumbnail(videoId) : null;
  const displayImage = youtubeThumb || src;

  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick(e);
      return false;
    }
  };

  const portfolioClassName = `cs-portfolio cs-bg ${variant ? variant : 'cs-style1'} ${
    isVideo && videoId ? 'cs-video' : ''
  }`;

  return (
    <a
      href={href}
      className={portfolioClassName}
      onClick={handleClick}
    >
      <>
        <Div className="cs-portfolio_hover" />
        <Div
          className="cs-portfolio_bg cs-bg"
          style={{ backgroundImage: `url("${displayImage}")` }}
        />
        
        {/* Video Play Button */}
        {isVideo && videoId && (
          <Div className="cs-video_play_button">
            <Div className="cs-play_icon" />
          </Div>
        )}
        
        {/* Original portfolio info (hidden for videos) */}
        {!isVideo && (
          <Div className="cs-portfolio_info">
            <Div className="cs-portfolio_info_bg cs-accent_bg" />
            <h2 className="cs-portfolio_title">{title}</h2>
            <Div className="cs-portfolio_subtitle">{subtitle}</Div>
          </Div>
        )}
      </>
    </a>
  );
}
